import { HStack, Stack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

interface SectionItemProps {
  testID: string;
  label?: string;
  labelDescription?: string;
  value?: string | React.ReactNode;
  isLast?: boolean;
  mobileValue?: string;
}

export const SectionItem: React.FC<SectionItemProps> = ({
  testID,
  label,
  value,
  isLast,
  mobileValue,
  labelDescription,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const renderValue = () => {
    if (isMobile && mobileValue) {
      return (
        <Text
          testID={`${testID}-value`}
          color="neutral.darkest"
          variant="regular"
          fontSize={Typography['fontsize.md']}>
          {mobileValue}
        </Text>
      );
    }
    if (typeof value === 'string' || typeof value === 'number') {
      return (
        <Text
          testID={`${testID}-value`}
          color={isMobile ? 'neutral.darkest' : 'black'}
          variant="regular"
          fontSize={Typography['fontsize.md']}>
          {value}
        </Text>
      );
    }
    return value;
  };

  return (
    <Stack
      direction={{ base: 'row', sm: 'column' }}
      testID={testID}
      alignItems={isLast ? 'flex-end' : 'flex-start'}
      {...(isMobile && {
        w: 'full',
        justifyContent: 'space-between',
        space: 'inline.quarck',
      })}>
      <HStack space="inline.quarck" alignItems="center">
        <Text
          testID={`${testID}-label`}
          color={isMobile ? 'neutral.dark' : 'black'}
          variant={isMobile ? 'regular' : 'semibold'}
          fontSize="md">
          {label}
        </Text>
        {labelDescription && !isMobile && (
          <Text testID={`${testID}-label-description`} color="neutral.dark" fontSize="xs">
            {labelDescription}
          </Text>
        )}
      </HStack>
      {renderValue()}
    </Stack>
  );
};
